import React from "react";
import { Link } from "react-router-dom";
import "./header.css";

function openMobileMenu(e) {
  if (window.screen.width < "1000") {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector(".mobile-menu").classList.toggle("show");
    return false;
  }
}

function Header({ className }) {
  let classes = ["main-header", className].join(" ");

  return (
    <div className={classes}>
      <div className="header-navs">
        <Link to="/services" className="header-link" onClick={openMobileMenu}>
          سرویس‌ها و راهکار‌های مپ
        </Link>
        {/* <Link to="/services" className="header-link" onClick={openMobileMenu}>
          راهکارهای مپ
        </Link> */}
        <a
          onClick={openMobileMenu}
          href="https://support.map.ir"
          target="_blank"
          rel="noopener noreferrer"
          className="header-link"
        >
          مستندات
        </a>
        <a
          onClick={openMobileMenu}
          href="https://corp.map.ir/contact-us/"
          target="_blank"
          rel="noopener noreferrer"
          className="header-link"
        >
          تماس با ما
        </a>
      </div>
      <div className="header-AR">
        <span id="show-demo-tour-wrapper">
          {/* <a
            onClick={openMobileMenu}
            href="https://corp.map.ir/registration/"
            target="_blank"
            rel="noopener noreferrer"
          >
            ورود / ثبت‌نام
          </a> */}
        </span>
      </div>
      <Link to="/" className="header-logo"></Link>
    </div>
  );
}

export default Header;
